export const COLOURS = {
  primary: "#FCF6E5",
  secondary: "#6A7A82",
  blue: "#3388F8",
  pink: "#C34681",
};
